import { render, staticRenderFns } from "./PerfilComponent.vue?vue&type=template&id=eb4a510e"
import script from "./PerfilComponent.vue?vue&type=script&lang=js"
export * from "./PerfilComponent.vue?vue&type=script&lang=js"
import style0 from "./PerfilComponent.vue?vue&type=style&index=0&id=eb4a510e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports